import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getKioskSession, getToken, getUser } from '../stores/session';
import type { Role } from '../types/api';
import { ChangePasswordPage } from './ChangePassword';

export function RequireAuth(props: { roles: Role[]; kiosk?: boolean; children: ReactNode }) {
  const loc = useLocation();
  const token = getToken();
  const user = getUser();
  if (!token || !user) {
    return <Navigate to={props.kiosk ? '/kiosk/login' : '/login'} replace state={{ from: loc.pathname }} />;
  }
  if (props.kiosk && !getKioskSession()) {
    return <Navigate to="/kiosk/login" replace />;
  }
  if (!props.roles.includes(user.role)) {
    return <Navigate to="/login" replace />;
  }
  if (user.must_change_password && loc.pathname !== '/change-password') {
    return <ChangePasswordPage />;
  }
  return <>{props.children}</>;
}
